import { Grid, Space, Table } from "../components/Layout";
import { Media, Title, Texts, Button } from "../components/Object";
import { Head, News, Banner, Contact } from "../components/Project";
import { HashLink } from "react-router-hash-link";

const Service = () => {
  return (
    <>
      <Head slug="page-company"></Head>
      <Space size={["160px", "64px"]} />
        {/* <List /> */}
        <Message />

        <Space size={['120px 0 0', '80px 0 0']}>
          <Information></Information>
        </Space>
      <Space size={["160px", "64px"]} />

      <Contact />

      <News />

      <Banner />
    </>
  );
};

export default Service;

export const Message = () => {
  return(
    <>
        <div className="l-row" data-state="min">
          <div className="c-grid--center">
            <Title slug="message" enClass="c-text--center" jpClass="c-text--center"></Title>
          </div>
          <Space size={['80px 0 24px', '40px 0 18px']}>
            <Texts slug="message/body"></Texts>
          </Space>
          <Texts slug="message/bottom" class="c-text--end c-text--bold"></Texts>
        </div>
    </>
  )
}

export const Information = () => {
  const addText = [
    ["会社名", "株式会社カナメカーゴ"],
    ["所在地", "〒651-2133 兵庫県神戸市西区枝吉2丁目91-1"],
    ["TEL", "078-920-9791"],
    ["FAX", "078-920-9792"],
    ["Mail", "info@kanamecargo.co.jp"],
    ["設立年月日", "令和元年9月"],
    ["資本金", "3,000,000円"],
    ["従業員数", "30名"],
    ["事業内容", "共同配送　JRコンテナ輸送　倉庫保管　軽貨物運送"],
    ["営業所", "【京都営業所】<br>奈良・滋賀・京都　共配センター<br>京都府木津川市加茂町大野唐岩42<br>TEL：0774-66-6912　FAX：0774-66-6913<br><br>【兵庫営業所】<br>兵庫県神戸市西区櫨谷町福谷766-1<br><br>【大阪営業所】<br>大阪府大阪市住之江区平林南2丁目12-22"],
    ["主要取引先", "神戸市・株式会社ミラク・株式会社栄進工業・株式会社ユアサ・濃飛倉庫運輸株式会社・船井総研ロジ株式会社・株式会社日本産業"],
  ];
  return (
    <>
      <div className="p-box__wrap--white" data-state="message">
        <Space size={['120px', '80px']}></Space>
        <div className="l-row l-row--normal" data-state="min">
          <Title slug="information-company" jpClass="c-text--center" enClass="c-text--center"></Title>
          <Space size={["48px", "32px"]}></Space>
          <Table slug="information" len={addText.length} addText={addText}></Table>
        </div>
        <Space size={['120px', '80px']}></Space>
      </div>
    </>
  );
}

